import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ImpersonationBroker, ITemplateCard } from '../../viewmodels/AppViewModels';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const EMAIL_CATEGORY_TEMPLATES_QUERY_KEY = 'emailCategoryTemplates';

export const useEmailCategoryTemplates = ({
	industry,
	categoryName,
	enabled = true,
	excludeExpired = true,
	sortBy = 'lastModifiedDate',
	retry,
	impersonationContext,
	meta,
}: {
	industry: Api.Industry;
	categoryName: string;
	excludeExpired?: boolean;
	sortBy?: 'lastModifiedDate' | 'name';
	enabled?: boolean;
	retry?: (failureCount: number, error: Api.IOperationResultNoValue) => boolean;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<ITemplateCard[]>(
				ImpersonationBroker.composeApiUrl({
					queryParams: {
						excludeExpired,
						sortBy,
					},
					urlPath: `template/${encodeURIComponent(industry)}/${encodeURIComponent(categoryName)}`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [
			EMAIL_CATEGORY_TEMPLATES_QUERY_KEY,
			industry,
			categoryName,
			excludeExpired,
			sortBy,
			impersonationContext,
		],
		retry,
		meta,
	});
};

export const invalidateEmailCategoryTemplates = () => {
	reactQueryClient.invalidateQueries({ queryKey: [EMAIL_CATEGORY_TEMPLATES_QUERY_KEY] });
};
